var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('img',{attrs:{"src":_vm.url,"id":"image"}}):_c('img',{attrs:{"src":"assets/layout/images/no-image.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }